import React from 'react';
import PropTypes from 'prop-types';
import EditorTypePropType from '../../prop-types/editor-type-prop-type';
import { editorTypeNameFromEditorType } from '../../constants/intl-messages/editor-type-messages';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { FormattedMessage, useIntl } from 'react-intl';
import { useEnabledEditorOptions } from './use-enabled-editor-options';
import messages from '../../messages';
import sharedStyles from '../shared-styles.module.less';

const FilterTypeSelector = ({ editorType, onChange }) => {
  const intl = useIntl();
  const currentEditorTypeMessage = editorTypeNameFromEditorType(editorType);
  const enabledOptions = useEnabledEditorOptions();

  return (
    <DropdownMenu className={sharedStyles['filter-type-selector']}>
      <DropdownMenuToggler ariaLabel={intl.formatMessage(messages.filterType)} className={sharedStyles['dropdown-toggler']}>
        <FormattedMessage {...currentEditorTypeMessage} />
      </DropdownMenuToggler>
      {enabledOptions.map((option) => (
        <DropdownMenuItem key={option} onClick={() => onChange(option)} selected={option === editorType}>
          {intl.formatMessage(editorTypeNameFromEditorType(option))}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

FilterTypeSelector.propTypes = {
  editorType: EditorTypePropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FilterTypeSelector;
